import {Pressable} from "react-native";
import {Text} from "./Text";

function Button(props: any) {
    return <Pressable  {...props} style={({pressed})=>[
        props.style, pressed ? props.pressedStyle : {}
    ]}>
        <Text style={props.textStyle}>{props.title}</Text>
    </Pressable>
}

export {Button};